module.exports = __webpack_public_path__ + "files/3e3fc789993391c39226c6d1547ac48b.woff2";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/droidserif-bold-webfont.woff2
// module id = 808
// module chunks = 60